import { z } from 'zod';

export const CompanySettingsSchema = z.object({
  id: z.string().uuid(),
  company_name: z.string(),
  address_line1: z.string(),
  address_line2: z.string(),
  phone: z.string(),
  email: z.string(),
  website: z.string(),
  license_number: z.string(),
  estimate_validity_days: z.number().int().default(30),
  payment_terms: z.string().default(''),
  lead_time_note: z.string().default(''),
  change_order_note: z.string().default(''),
  footer_note: z.string().default(''),
  kerf_width: z.number().default(0.125),
  cnc_enabled: z.boolean().default(false),
  cnc_feed_rate: z.number().default(400),
  cnc_rapid_rate: z.number().default(800),
  cnc_sheet_load_time: z.number().default(1.5),
  cnc_sheet_unload_time: z.number().default(1.0),
  cnc_part_cleanup_time: z.number().default(0.25),
  cnc_setup_time: z.number().default(15.0),
  cnc_operator_rate: z.number().default(35),
  cnc_machine_overhead_rate: z.number().default(25),
  cnc_bit_price: z.number().default(45),
  cnc_sheets_per_bit: z.number().int().default(50),
  cnc_reference_batch_qty: z.number().int().min(1).default(10),
  texture_folder_path: z.string().default(''),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateCompanySettingsSchema = z.object({
  company_name: z.string().min(1, 'Company name is required'),
  address_line1: z.string().default(''),
  address_line2: z.string().default(''),
  phone: z.string().default(''),
  email: z.string().default(''),
  website: z.string().default(''),
  license_number: z.string().default(''),
  estimate_validity_days: z.number().int().default(30),
  payment_terms: z.string().default(''),
  lead_time_note: z.string().default(''),
  change_order_note: z.string().default(''),
  footer_note: z.string().default(''),
  kerf_width: z.number().default(0.125),
  cnc_enabled: z.boolean().default(false),
  cnc_feed_rate: z.number().default(400),
  cnc_rapid_rate: z.number().default(800),
  cnc_sheet_load_time: z.number().default(1.5),
  cnc_sheet_unload_time: z.number().default(1.0),
  cnc_part_cleanup_time: z.number().default(0.25),
  cnc_setup_time: z.number().default(15.0),
  cnc_operator_rate: z.number().default(35),
  cnc_machine_overhead_rate: z.number().default(25),
  cnc_bit_price: z.number().default(45),
  cnc_sheets_per_bit: z.number().int().default(50),
  cnc_reference_batch_qty: z.number().int().min(1).default(10),
  texture_folder_path: z.string().default(''),
});

export const UpdateCompanySettingsSchema = CreateCompanySettingsSchema.partial();

export type CompanySettings = z.infer<typeof CompanySettingsSchema>;
export type CreateCompanySettings = z.infer<typeof CreateCompanySettingsSchema>;
export type UpdateCompanySettings = z.infer<typeof UpdateCompanySettingsSchema>;
